import React,{useRef} from 'react'

import bg from '../../../images/partners.jpg'

import cifor from '../../../images/logo-cifor.png'
import stirling from '../../../images/logo-stirling.svg'
import wcs from '../../../images/logo-wcs.png'
import usfws from '../../../images/logo-usfws.png'
import usaid from '../../../images/logo-usaid.png'
import ec from '../../../images/logo-ec.svg'
// import ukri from '../../../images/logo-ukri.svg'
// import tradehub from '../../../images/logo-trade-hub.png'

const PopupPartners = ({show}) => {

  const popupDefaultRef = useRef()

  return (
    <>
      {
        !show ? null : (
          <div className="popup-child" style={{display:`${show === 'Partners' ? '' : 'none'}`,opacity:`${show ? 1 : 0}`}}>
            <div className="popup-image-head" style={{background:`#000 url(${bg}) center center`,backgroundSize:'cover'}}>
              <div/>
              <section>
                <h6>Our Partners</h6>
                <small>Header photo: © Unsplash</small>
              </section>
            </div>
            <div className="popup-child-text">
              <p>
                The WILDMEAT Database Explorer has been created by the WILDMEAT project partners (CIFOR, the University of Stirling and WCS) with support from IRET, Gabon. We are funded by USFWS and USAID.
              </p>

              <a href="https://www.cifor.org/" target="_blank" rel="noopener noreferrer">
                <img src={cifor} style={{width:50,height:'auto',marginRight:15,marginBottom:15}} alt="cifor"/>
              </a>
              <a href="https://www.stir.ac.uk/" target="_blank" rel="noopener noreferrer">
                <img src={stirling} style={{width:200,height:'auto',marginRight:15,marginBottom:15}} alt="stirling"/>
              </a>
              <a href="https://www.wcs.org/" target="_blank" rel="noopener noreferrer">
                <img src={wcs} style={{width:200,height:'auto',marginRight:15,marginBottom:15}} alt="wcs"/>
              </a>

              <h6 style={{
                marginBottom: 15,opacity: 0.4,fontWeight: 700,fontSize: 13,letterSpacing: 1
              }}>FUNDERS:</h6>

              <a href="https://www.fws.gov/" target="_blank" rel="noopener noreferrer">
                <img src={usfws} style={{width:50,height:'auto',marginRight:15,marginBottom:15}} alt="usfws"/>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <img src={usaid} style={{width:200,height:'auto',marginRight:15,marginBottom:15}} alt="usaid"/>
              </a>
              <a href="https://www.usaid.gov/" target="_blank" rel="noopener noreferrer">
                <img src={ec} style={{width:220,height:'auto',marginRight:15,marginBottom:15}} alt="ec"/>
              </a>
              {
                /*
                <a href="https://www.ukri.org/" target="_blank" rel="noopener noreferrer">
                  <img src={ukri} style={{width:180,height:'auto',marginRight:15,marginBottom:15}} alt="ukri"/>
                </a>
                <a href="https://tradehub.earth/" target="_blank" rel="noopener noreferrer">
                  <img src={tradehub} style={{width:240,height:'auto',marginRight:15,marginBottom:15}} alt="trade-hub"/>
                </a>
                */
              }

            </div>
          </div>
        )
      }
    </>
  )
}
export default PopupPartners
